import { HttpClient } from "helpers/http/httpClient";
import { BaseResponseType, DataGridRequest, PagedResult } from "services/shared-models/sharedTypes";
import {RewardResponse, UpdateRewardRequest } from "./models";
import {AxiosResponse} from "axios";

export const RewardsService = {
    updateExaminerReward: async (id: number, request: UpdateRewardRequest) => {
         console.log(request);
        return HttpClient.put<BaseResponseType<RewardResponse>>(`/api/Rewards/UpdateExaminerReward/${id}`, request);
    },
    rejectExaminerReward: async (id: number) => {
        return HttpClient.put<BaseResponseType<RewardResponse>>(`/api/Rewards/RejectExaminerReward/${id}`);
    },
    getExaminersRewardById: async (id: number) => {
        return HttpClient.get<BaseResponseType<RewardResponse>>(`/api/Rewards/GetExaminersRewardById/${id}`);
    },
    getAllExaminersRewards: async (request: DataGridRequest) => {
        return HttpClient.post<BaseResponseType<PagedResult<RewardResponse>>>(`/api/Rewards/GetAllExaminersRewards`, request);
    },
    exportExaminersRewardsToExcel: async (request: DataGridRequest) => {
        return HttpClient.post<AxiosResponse<Blob>>(`/api/Rewards/ExportExaminersRewardsToExcel`, request, {
            responseType: "blob",
        });
    },
    getAllExaminerRewardsForCurrentUser: async (request: DataGridRequest) => {
        return HttpClient.post<BaseResponseType<PagedResult<RewardResponse>>>(`/api/Rewards/GetAllExaminerRewardsForCurrentUser`, request);
    },
    exportCurrentExaminerRewardsToExcel: async (request: DataGridRequest) => {
        return HttpClient.post<AxiosResponse<Blob>>(`/api/Rewards/ExportCurrentExaminerRewardsToExcel`, request,{
            responseType: "blob",
        });
    },
    updateRefereeReward: async (id: number, request: UpdateRewardRequest) => {
        return HttpClient.put<BaseResponseType<RewardResponse>>(`/api/Rewards/UpdateRefereeReward/${id}`, request);
    },
    rejectRefereeReward: async (id: number) => {
        return HttpClient.put<BaseResponseType<RewardResponse>>(`/api/Rewards/RejectRefereeReward/${id}`);
    },
    getRefereesRewardById: async (id: number) => {
        return HttpClient.get<BaseResponseType<RewardResponse>>(`/api/Rewards/GetRefereesRewardById/${id}`);
    },
    getAllRefereesRewards: async (request: DataGridRequest) => {
        return HttpClient.post<BaseResponseType<PagedResult<RewardResponse>>>(`/api/Rewards/GetAllRefereesRewards`, request);
    },
    exportRefereesRewardsToExcel: async (request: DataGridRequest) => {
        return HttpClient.post<AxiosResponse<Blob>>(`/api/Rewards/ExportRefereesRewardsToExcel`, request,{
            responseType: "blob",
        });
    },
    getAllRefereeRewardsForCurrentUser: async (request: DataGridRequest) => {
        return HttpClient.post<BaseResponseType<PagedResult<RewardResponse>>>(`/api/Rewards/GetAllRefereeRewardsForCurrentUser`, request);
    },
    exportCurrentRefereeRewardsToExcel: async (request: DataGridRequest) => {
        return HttpClient.post<AxiosResponse<Blob>>(`/api/Rewards/ExportCurrentRefereeRewardsToExcel`, request,{
            responseType: "blob",
        });
    },
    updateAuthorReward: async (id: number, request: UpdateRewardRequest) => {
        return HttpClient.put<BaseResponseType<RewardResponse>>(`/api/Rewards/UpdateAuthorReward/${id}`, request);
    },
    rejectAuthorReward: async (id: number) => {
        return HttpClient.put<BaseResponseType<RewardResponse>>(`/api/Rewards/RejectAuthorReward/${id}`);
    },
    getAuthorsRewardById: async (id: number) => {
        return HttpClient.get<BaseResponseType<RewardResponse>>(`/api/Rewards/GetAuthorsRewardById/${id}`);
    },
    getAllAuthorsRewards: async (request: DataGridRequest) => {
        return HttpClient.post<BaseResponseType<PagedResult<RewardResponse>>>(`/api/Rewards/GetAllAuthorsRewards`, request);
    },
    exportAuthorsRewardsToExcel: async (request: DataGridRequest) => {
        return HttpClient.post<AxiosResponse<Blob>>(`/api/Rewards/ExportAuthorsRewardsToExcel`, request,{
            responseType: "blob",
        });
    },
    getAllAuthorRewardsForCurrentUser: async (request: DataGridRequest) => {
        return HttpClient.post<BaseResponseType<PagedResult<RewardResponse>>>(`/api/Rewards/GetAllAuthorRewardsForCurrentUser`, request);
    },
    exportCurrentAuthorRewardsToExcel: async (request: DataGridRequest) => {
        return HttpClient.post<AxiosResponse<Blob>>(`/api/Rewards/ExportCurrentAuthorRewardsToExcel`, request,{
            responseType: "blob",
        });
    },
} as const;